import React, { PureComponent } from "react"
import { Dialog } from "@tencent/spaui"
import { CheckboxGroup, Icon } from "@tencent/spaui"
import "./index.scoped.less"
export default class CheckAgency extends PureComponent {
  state = { childVal: [], parentVal: [] }
  handleChange = (e, value, n) => {
    const { data = {} } = this.props
    this.setState({ [n]: value }, () => {
      this.props.handleChange(data.agency_uid, [...this.state.parentVal, ...this.state.childVal])
    })
  }

  render() {
    const { childVal, parentVal } = this.state
    const { data = {} } = this.props
    const childArr = data.data || []
    return (
      <div className="checkAgencyBox">
        <CheckboxGroup className="parentAgency" checkAll={true} data={[data]} checkAllLabel="服务商" value={parentVal} onChange={(e, v) => this.handleChange(e, v, "parentVal")} />
        {childArr.length !== 0 ? <CheckboxGroup className="childAgency" checkAll={true} data={childArr} checkAllLabel="子账号" value={childVal} onChange={(e, v) => this.handleChange(e, v, "childVal")} /> : null}
      </div>
    )
  }
}
